export default "__VITE_ASSET__BWupO6rO__"